import HomeRoundedIcon from '@mui/icons-material/HomeRounded'
import EventNoteRoundedIcon from '@mui/icons-material/EventNoteRounded'
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded'
import FolderRoundedIcon from '@mui/icons-material/FolderRounded'
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded'
import HowToRegRoundedIcon from '@mui/icons-material/HowToRegRounded'
import QrCode2RoundedIcon from '@mui/icons-material/QrCode2Rounded'
import PlayCircleRoundedIcon from '@mui/icons-material/PlayCircleRounded'
import ConnectWithoutContactRoundedIcon from '@mui/icons-material/ConnectWithoutContactRounded'
import InfoRoundedIcon from '@mui/icons-material/InfoRounded'
import type { SvgIconComponent } from '@mui/icons-material'

export interface NavItem {
  /**
   * Stable key for built-in items (used by the admin nav-settings + the
   * content-availability summary). Absent for admin-created custom pages.
   */
  key?: string
  label: string
  /** Sub-path within the app base (e.g. '' for home, 'agenda'). */
  sub: string
  icon: SvgIconComponent
  /**
   * Whether this is a "primary" destination. Advisory: the mobile bottom bar
   * shows the first few nav items directly and moves the rest into a "More"
   * sheet, so every item stays reachable regardless of this flag. Kept to
   * document intent and drive ordering.
   */
  primary: boolean
}

export const NAV_ITEMS: NavItem[] = [
  { key: 'home', label: 'Home', sub: '', icon: HomeRoundedIcon, primary: true },
  { key: 'agenda', label: 'Agenda', sub: 'agenda', icon: EventNoteRoundedIcon, primary: true },
  { key: 'speakers', label: 'Speakers', sub: 'speakers', icon: GroupsRoundedIcon, primary: true },
  { key: 'content', label: 'Content', sub: 'content', icon: FolderRoundedIcon, primary: true },
  { key: 'forms', label: 'Forms', sub: 'forms', icon: AssignmentRoundedIcon, primary: true },
  { key: 'register', label: 'Register', sub: 'my-registration', icon: HowToRegRoundedIcon, primary: true },
  { key: 'info', label: 'Event Info', sub: 'info', icon: InfoRoundedIcon, primary: false },
  { key: 'network', label: 'Network', sub: 'network', icon: ConnectWithoutContactRoundedIcon, primary: false },
  { key: 'badge', label: 'My badge', sub: 'badge', icon: QrCode2RoundedIcon, primary: false },
  { key: 'watch', label: 'Watch', sub: 'watch', icon: PlayCircleRoundedIcon, primary: false },
]
